import styled from "@emotion/styled";
import { useClerk } from "@clerk/clerk-react";
import { useState } from "react";
import HelloprenupLogoWithText from "../icons/HelloprenupLogoWithText.tsx";
import MobileMenu from "../icons/Menu.tsx";
import CloseIcon from "../icons/CloseIcon.tsx";
import { SecondaryButtonSmall } from "../buttons/SecondaryButton";
import { COLOR_APP_TEXT } from "../theme.ts";
import { ParagraphHeaderSmall } from "../typography/Paragraph";
import Divider from "../Divider";
import Footer from "./Footer.tsx";
import { useNavItems, bottomNavItems } from "./utils/nav.tsx";
import { CircleIconButton, IconButton } from "../buttons/IconButton.tsx";
import WarningPopup from "../popups/Warning.tsx";
import SectionList from "./SectionList.tsx";
import { useDispatch } from "react-redux";
import Nav from "./utils/mobile/Nav";
import {
  NavBarRightItems,
  DrawerHeader,
  DrawerItemGroup,
  ScrollableNavItems,
  Link,
} from "./utils/mobile/components";
import Drawer from "./utils/mobile/Drawer";
import DrawerItem from "./utils/mobile/DrawerItem";
import AttorneyServicesComponent from "../AttorneyServicesComponent.tsx";
import { useLocation } from "react-router";

const NonScrollableNavItems = styled.div`
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MobileNav = () => {
  const { signOut } = useClerk();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const navItems = useNavItems();
  const dispatch = useDispatch();
  const location = useLocation();

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleLogout = () => {
    setIsDrawerOpen(false);
    setShowLogoutPopup(true);
  };

  const handleConfirmLogout = async () => {
    setShowLogoutPopup(false);
    dispatch({ type: "USER_LOGOUT" });
    await signOut({ redirectUrl: "/login" });
  };

  const handleCancelLogout = () => {
    setShowLogoutPopup(false);
  };

  return (
    <>
      {showLogoutPopup && (
        <WarningPopup
          title="Are you sure you want to log out?"
          description="Remember, you must complete your prenup before your marriage date!"
          buttons={{
            confirmText: "Log out",
            cancelText: "Cancel",
            onConfirm: handleConfirmLogout,
            onCancel: handleCancelLogout,
          }}
        />
      )}
      <Nav>
        <HelloprenupLogoWithText />
        <NavBarRightItems>
          <AttorneyServicesComponent />
          <IconButton onClick={toggleDrawer}>
            <MobileMenu />
          </IconButton>
        </NavBarRightItems>
      </Nav>
      {isDrawerOpen && (
        <Drawer>
          <DrawerHeader>
            <HelloprenupLogoWithText />
            <CircleIconButton onClick={toggleDrawer}>
              <CloseIcon />
            </CircleIconButton>
          </DrawerHeader>
          <ScrollableNavItems>
            {navItems.map((item) => (
              <DrawerItemGroup key={item.label} isDisabled={item.isDisabled}>
                <Link
                  onClick={() => {
                    setIsDrawerOpen(false);
                  }}
                  to={item.sections?.[0] ? item.sections[0].path : item.path}
                  key={item.label}
                >
                  <DrawerItem isActive={location.pathname === item.path}>
                    {item.icon}
                    <ParagraphHeaderSmall color={COLOR_APP_TEXT}>
                      {item.label}
                    </ParagraphHeaderSmall>
                  </DrawerItem>
                </Link>
                {/* Render sections as separate items underneath */}
                {item.sections && location.pathname.includes(item.path) && (
                  <SectionList
                    sections={item.sections}
                    error={item.sectionsError ?? ""}
                    loading={item.sectionsLoading}
                    setIsExpanded={setIsDrawerOpen}
                  />
                )}
              </DrawerItemGroup>
            ))}
          </ScrollableNavItems>
          <Divider />
          <NonScrollableNavItems>
            {bottomNavItems.map((item) => (
              <Link
                onClick={() => {
                  setIsDrawerOpen(false);
                }}
                to={item.path}
                key={item.label}
              >
                <DrawerItem isActive={location.pathname === item.path}>
                  {item.icon}
                  <ParagraphHeaderSmall color={COLOR_APP_TEXT}>
                    {item.label}
                  </ParagraphHeaderSmall>
                </DrawerItem>
              </Link>
            ))}
            <SecondaryButtonSmall onClick={handleLogout}>
              Sign out
            </SecondaryButtonSmall>
            <Footer />
          </NonScrollableNavItems>
        </Drawer>
      )}
    </>
  );
};

export default MobileNav;
